import script from "./flow-record-sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./flow-record-sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./flow-record-sidebar.vue?vue&type=style&index=0&id=78c951b0&lang=scss&scoped=true"
import "./flow-record-sidebar.vue?vue&type=style&index=1&id=78c951b0&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c951b0"]])

export default __exports__